export const updateNotifierEnglish = {
  updateFoundTitle: 'A new version of {{appName}} is available',
  updateFoundDescription: 'Refresh to get the latest version',
  refreshButtonText: 'Refresh',
};
